import { useEffect, useRef } from 'react';
import QRCode from 'qrcode';

/**
 * Rendert eine otpauth-URL lokal als QR-Code. Bewusst clientseitig — das
 * TOTP-Geheimnis verlässt nie das System (ADR 0034).
 */
export function QrCanvas({ value, size = 200 }: { value: string; size?: number }) {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (canvasRef.current) {
      void QRCode.toCanvas(canvasRef.current, value, { width: size, margin: 1 });
    }
  }, [value, size]);

  return <canvas ref={canvasRef} className="rounded border border-border" aria-label="QR-Code" />;
}
